package com.example.mystybag.sharedmodels.project.responseModels.merchant

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class MerchantStaffItemResponse(
    val id: Long = 0L,
    val email: String? = null,
    val firstName: String? = null,
    val lastName: String? = null,
    val phoneNumber: String? = null,
    val dialCode: String? = null,
    val role: String? = null,
    val isActive: Boolean = true,
    val merchantLocationIds: List<Long>? = null,
    /** Permission: this staff member can create new bags. Locations are owner-only and never granted to staff. */
    val canCreateBags: Boolean = false,
    /** Permission: this staff member can see the revenue value on the dashboard (otherwise it's masked). */
    val canViewRevenue: Boolean = false,
)

@Serializable
data class GetMerchantStaffResponseModel(
    @SerialName("staff_list")
    val staffList: List<MerchantStaffItemResponse> = emptyList()
) : BaseResponseModel()
